import React from 'react';
import PropTypes from 'prop-types';
import { resetStyles, formLoadHandler } from './formSubmissionHandlers';
import Alert from '../Alert';

import './marketoForm.scss';

class MarketoForm extends React.Component {
  constructor(props) {
    super(props);

    this.marketoConfig = {
      podId: '//app-lon10.marketo.com',
      munchkinId: '897-MBC-207',
    };

    this.handleForm = this.handleForm.bind(this);
  }

  componentDidMount() {
    const script = document.createElement('script');
    script.id = 'marketoForms2';
    script.onload = this.handleForm;
    script.src = '//app-lon10.marketo.com/js/forms2/js/forms2.min.js';
    document.body.appendChild(script);
  }

  componentWillUnmount() {
    const marketoScript = document.getElementById('marketoForms2');
    if (marketoScript) {
      marketoScript.outerHTML = '';
    }
  }

  handleForm() {
    const { formId } = this.props;

    // eslint-disable-next-line no-undef
    MktoForms2.loadForm(
      this.marketoConfig.podId,
      this.marketoConfig.munchkinId,
      formId,
      formLoadHandler,
    );
    // eslint-disable-next-line no-undef
    MktoForms2.whenRendered(form => setTimeout(() => resetStyles(form), 0));
  }

  render() {
    const { customConfirmationMessage, formId, gtmEventName } = this.props;

    const messageToUser = customConfirmationMessage || 'Thank you. We\'ll be in touch soon';

    return (
      <React.Fragment>
        { /* the div with id "marketoForm" below is used
        to override original marketo form css */ }
        <div id="marketoForm">
          <form
            className="gs-marketo-form"
            data-title={gtmEventName}
            id={`mktoForm_${formId}`}
          />
        </div>
        <div
          data-test="confirmation-text"
          id="confirmationText"
          style={{ visibility: 'hidden' }}
        >
          <Alert
            type="success"
            message={messageToUser}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default MarketoForm;

MarketoForm.defaultProps = {
  customConfirmationMessage: null,
  gtmEventName: '',
};

MarketoForm.propTypes = {
  customConfirmationMessage: PropTypes.string,
  formId: PropTypes.string.isRequired,
  gtmEventName: PropTypes.string,
};
